export enum ScrollDirection {
  UP = 'up',
  DOWN = 'down'
}
